import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Server, Globe, CreditCard, MessageSquare, Rocket, Key, Users, Settings, BarChart3, LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import BrandMark from '@/components/atoms/BrandMark';

const links = [
  { label: 'Dashboard', href: '/portal', icon: LayoutDashboard },
  { label: 'Services', href: '/portal/services', icon: Server },
  { label: 'Domains', href: '/portal/domains', icon: Globe },
  { label: 'Billing', href: '/portal/billing', icon: CreditCard },
  { label: 'Tickets', href: '/portal/tickets', icon: MessageSquare },
  { label: 'Migrate', href: '/portal/migrate', icon: Rocket },
  { label: 'API Keys', href: '/portal/keys', icon: Key },
  { label: 'Teams', href: '/portal/teams', icon: Users },
  { label: 'Usage', href: '/portal/usage', icon: BarChart3 },
  { label: 'Settings', href: '/portal/settings', icon: Settings },
];

const PortalLayout = ({ children }) => {
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-obsidian text-signal flex">
      {/* Sidebar */}
      <aside className="hidden lg:flex w-60 flex-col border-r border-signal/10 bg-obsidian-elevated">
        <div className="p-4 border-b border-signal/10">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/logo-drklynx-sm.png" alt="DrkLynX" className="w-12 h-12 rounded-md" />
            <BrandMark size="md" />
          </Link>
          <div className="font-mono text-[9px] text-cyan/60 mt-1 uppercase tracking-wider">Client Portal</div>
        </div>
        <nav className="flex-1 py-3 overflow-y-auto" aria-label="Portal navigation">
          {links.map((l) => {
            const active = location.pathname === l.href || (l.href !== '/portal' && location.pathname.startsWith(l.href));
            return (
              <Link key={l.href} to={l.href} data-testid={`portal-nav-${l.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-fast mx-2 rounded-md ${active ? 'bg-cyan/10 text-cyan' : 'text-steel hover:text-signal hover:bg-signal/5'}`}>
                <l.icon className="w-4 h-4" /> {l.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-signal/10">
          <div className="text-xs text-steel truncate mb-2">{user?.email}</div>
          <button onClick={logout} className="flex items-center gap-2 text-sm text-steel-muted hover:text-error transition-colors duration-fast">
            <LogOut className="w-4 h-4" /> Sign Out
          </button>
        </div>
      </aside>
      {/* Content */}
      <div className="flex-1 min-w-0">
        <main className="p-6 lg:p-8 max-w-7xl">{children}</main>
      </div>
    </div>
  );
};

export default PortalLayout;
